export enum DeviceType {
   DESKTOP = "DESKTOP",
   MOBILE = "MOBILE",
   ALL= "ALL",
   
}